import Route from '@ember/routing/route';
import { service } from '@ember/service';
import { instrumentRoutePerformance } from '@sentry/ember';

class RoadmapTableInitiativeSettingsStrategyRoute extends Route {
  @service router;

  beforeModel() {
    this.router.transitionTo('backlog.initiatives.initiative.investments');
  }

  model() {
    return this.modelFor('backlog.initiatives.initiative');
  }
}

export default instrumentRoutePerformance(
  RoadmapTableInitiativeSettingsStrategyRoute,
);
